import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['trigger', 'target'];

	connect() {
		this.header = document.querySelector('.header');

		this.triggerTargets.forEach((trigger) => {
			trigger.addEventListener('click', (event) => {
				event.preventDefault();
				this.scrollToTarget();
			});
		});
	}

	scrollToTarget() {
		if (!this.targetTarget) return;

		const headerHeight = this.header ? this.header.offsetHeight : 0;
		const targetPosition = this.targetTarget.getBoundingClientRect().top + window.scrollY;
		const scrollPosition = targetPosition - headerHeight;

		window.scrollTo({
			top: scrollPosition,
			behavior: 'smooth',
		});
	}
}
